import { Div } from "../../html";
import { cssModule, useSlots } from "../../shared";
import { useMemo } from "react";
import { Text } from "../../typography";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function useTile({
  active,
  children,
  focus,
  hover,
  orientation,
  variant
}) {
  const {
    content,
    heading,
    illustration,
    image
  } = useSlots(children, useMemo(() => ({
    _: {
      required: ["heading", "content"]
    },
    content: {
      as: Text,
      className: "o-ui-tile-content"
    },
    heading: {
      as: "span",
      className: "o-ui-tile-heading",
      size: "xs"
    },
    illustration: {
      className: "o-ui-tile-illustration",
      orientation: orientation === "horizontal" ? "vertical" : "horizontal"
    },
    image: {
      className: "o-ui-tile-image"
    }
  }), [orientation]));

  const imageMarkup = image && /*#__PURE__*/_jsx(Div, {
    className: "o-ui-tile-thumbnail",
    children: image
  });

  return {
    markup: /*#__PURE__*/_jsxs(_Fragment, {
      children: [imageMarkup, illustration, /*#__PURE__*/_jsxs(Div, {
        className: "o-ui-tile-main",
        children: [heading, content]
      })]
    }),
    tileProps: {
      className: cssModule("o-ui-tile", variant, orientation, active && "active", focus && "focus", hover && "hover")
    }
  };
}